import React, { useContext, useState } from "react";
import { Route, Routes } from "react-router-dom";
import ProtectRoute from "./ProtectedRoute";
import LogIn from "../pages/LogIn";
import ActorManagement from "../pages/Actor";
import InfluencerManagement from "../pages/Influencer";
import DirectorManagement from "../pages/Director";
import AuditionsManagement from "../pages/Auditions";
import OtpLogin from "../pages/OtpLogin";
import KYCManagement from "../pages/KYC";

/**
 * @author Sarthak Sharma.
 * @since 08-12-2023.
 * @description Admin Application URL Mapping.
 * @returns Routes
 */

const adminRouting = (): React.ReactElement => {
  return (
    <Route path="admin">
      <Route index path="login" element={<LogIn />} />
      <Route index path="otp" element={<OtpLogin />} />
      <Route element={<ProtectRoute />}>
        <Route index element={<ActorManagement />} />
        <Route index path="actor" element={<ActorManagement />} />
        <Route index path="influencer" element={<InfluencerManagement />} />
        <Route index path="director" element={<DirectorManagement />} />
        <Route index path="auditions" element={<AuditionsManagement />} />
        <Route index path="kyc" element={<KYCManagement />} />
      </Route>
    </Route>
  );
};

export default adminRouting;
